import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import ModalWrapper from 'dashboard/components/ModalWrapper';
import { ModalBody, ModalContainer, ModalFooter, ModalHeader } from 'dashboard/layouts/ModalLayout';
import Button from 'design-system/components/Button';
import { HStack } from 'design-system/components/Stack';
import { Paragraph } from 'design-system/components/Text';

const StyledModalBody = styled(ModalBody)`
  ${Paragraph} + ${Paragraph} {
    margin-top: ${Spacing[2]};
  }
`;

const ListContainer = styled.div`
  color: ${({ theme }) => theme.color.text.secondary};
  margin: ${Spacing[4]};
`;

type ConfirmDeleteFieldModalProps = {
  isOpen: boolean;
  handleClose: () => void;
  handleConfirmDelete: () => void;
  fieldsToDelete: string[];
};

const ConfirmDeleteFieldModal = ({
  isOpen,
  handleClose,
  handleConfirmDelete,
  fieldsToDelete,
}: ConfirmDeleteFieldModalProps) => {
  const plural = fieldsToDelete.length > 1;
  const pluralS = plural ? 's' : '';
  return (
    <ModalWrapper isOpen={isOpen} handleCloseModal={handleClose}>
      <ModalContainer>
        <ModalHeader onClose={handleClose}>Delete field{pluralS}?</ModalHeader>
        <StyledModalBody>
          <Paragraph>
            The field{pluralS} below {plural ? 'are' : 'is'} no longer referenced within the
            template:
          </Paragraph>
          <ListContainer>
            <ul>
              {fieldsToDelete.map((fieldKey) => (
                <li key={fieldKey}>{fieldKey}</li>
              ))}
            </ul>
          </ListContainer>
          <Paragraph>Would you like to delete {plural ? 'them' : 'it'}?</Paragraph>
        </StyledModalBody>
        <ModalFooter>
          <HStack equal>
            <Button
              id='confirm-delete-fields-component__confirm'
              variant='basic'
              onClick={handleClose}
            >
              Keep Field{pluralS}
            </Button>
            <Button
              id='confirm-delete-fields-component__confirm'
              variant='danger'
              onClick={handleConfirmDelete}
            >
              Delete Field{pluralS}
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContainer>
    </ModalWrapper>
  );
};

export default ConfirmDeleteFieldModal;
